import PropTypes from "prop-types"
import ScrollButton from "../ScrollButton/ScrollButton"
// Styles
import {
   Container,
   Wrapper,
   Overlay,
   Image,
   Text,
   Title,
} from "./PageSectionSolo.styles"

const PageSectionSolo = ({ image, title, text, scrollContainer }) => {
   return (
      <Container>
         <Image src={image} />
         <Overlay />
         <Wrapper>
            <Title
               dangerouslySetInnerHTML={{
                  __html: title?.replace(/\n/g, "<br />"),
               }}
            />
            <Text
               dangerouslySetInnerHTML={{
                  __html: text?.replace(/\n/g, "<br />"),
               }}
            />
         </Wrapper>
         <ScrollButton orientation="down" scrollContainer={scrollContainer} />
      </Container>
   )
}

PageSectionSolo.propTypes = {
   image: PropTypes.string,
   title: PropTypes.string,
   text: PropTypes.string,
   scrollContainer: PropTypes.object,
}

export default PageSectionSolo
